import Deconection from "assets/jpeg/deconecter.png";
import classNames from "classnames";
import { reactLocalStorage } from "reactjs-localstorage";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "contexts/UserContext";
import Logo from "../assets/jpeg/logo.jpeg";

const AppHeaderDesktop = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { setUser, user } = useContext(UserContext);
  return (
    <div className="sticky top-0 shadow-md z-50">
      <header
        className={`bg-white flex flex-row items-center justify-between px-4
      md:px-8 py-4 space-x-4 shadow-header sticky top-0 z-50 h-14`}
      >
        <div className="flex space-x-8 items-center w-full justify-between">
          <ul
            className="flex flex-shrink-0 text-parcours-shn text-sm items-center gap-1 w-auto hover:cursor-pointer h-[12px]"
            onClick={() => {
              navigate("/");
            }}
          >
            <img src={Logo} alt="Logo" style={{ width: 50, height: 50 }} />
          </ul>
          {user?.user?.role === "admin" && (
            <div
              className={classNames(
                "hover:cursor-pointer font-bold	text-[16px] text-[#5d55e8]",
                location?.pathname === "/" && " underline underline-offset-8 "
              )}
              onClick={() => {
                navigate("/");
              }}
            >
              Transfers
            </div>
          )}
          {user?.user?.role === "admin" && (
            <div
              className={classNames(
                "hover:cursor-pointer font-bold	text-[16px] text-[#5d55e8]",
                location?.pathname === "/balance" &&
                  " underline underline-offset-8 "
              )}
              onClick={() => {
                navigate("/balance");
              }}
            >
              Balance
            </div>
          )}
          {user?.user?.role === "admin" && (
            <div
              className={classNames(
                "hover:cursor-pointer font-bold	text-[16px] text-[#5d55e8]",
                location?.pathname === "/agent" &&
                  " underline underline-offset-8 "
              )}
              onClick={() => {
                navigate("/agent");
              }}
            >
              Agents
            </div>
          )}
          <div className={classNames("flex space-x-2")}>
            <button
              onClick={() => {
                reactLocalStorage.remove("var");
                setUser(null);
                return navigate("/login");
              }}
              style={{ width: user?.user?.role === "agent" ? 114 : 50 }}
              className="flex space-x-2  rounded-md justify-center items-center"
            >
              <img
                className="lg:block "
                src={Deconection}
                alt="Logo de Beta.gouv.fr"
                style={{ width: 25, height: 25 }}
              />
              {user?.user?.role === "agent" && (
                <span className=" text-lena2021-blue-dark hover:cursor-pointer font-bold	text-[14px]',">
                  Déconnecter
                </span>
              )}
            </button>
          </div>
        </div>
      </header>
    </div>
  );
};

export default AppHeaderDesktop;
